function Home() {
	return (
			<div className="centered">
			Welcome to the Crowdsec Playground!<br />
			Here you can debug your grok patterns, create notification templates, and more!
			</div>
	);
}

export default Home;